import React from "react";
import { IoIosMenu } from "react-icons/io";
import { Link } from "react-router-dom";
import SideNav from "./SideNav";

const MobileNav = ({ isSidenavOpen, toggleSidenav }) => {
  return (
    <nav className="flex items-center justify-between bg-slate-200 py-2 px-2">
      <Link to="/">
        <img
          src="/images/recipe_logo.svg"
          alt="logo"
          className="ml-[-55px] w-[250px] aspect-[2/0.25]"
        />
      </Link>
      <IoIosMenu size={30} onClick={toggleSidenav} />
      {isSidenavOpen && <SideNav toggleMenu={toggleSidenav} />}
    </nav>
  );
};

export default MobileNav;
